class ColorVariantDisplay {
constructor() {
  this.init();
}

init() {
  try {
    const productCards = document.querySelectorAll('.card-wrapper[data-has-colors="true"]');
   
    productCards.forEach((card, index) => {
      try {
        const swatches = card.querySelectorAll('.color-swatch:not(.disabled)');
       
        if (swatches.length > 0) {
          swatches.forEach(swatch => {
            swatch.addEventListener('click', (e) => {
              e.preventDefault();
             
              // Get the variant image URL
              const imageUrl = swatch.dataset.imageUrl;

              if (imageUrl && imageUrl !== 'undefined' && !imageUrl.includes('Liquid error')) {
                this.switchProductImage(card, imageUrl);
              }
            });
          });
        }
      } catch (cardError) {
        console.error(`Error processing card ${index + 1}:`, cardError);
      }
    });

    // Initialize hover events for all swatches
    this.setupSwatchHoverEvents();
  } catch (error) {
    console.error('Error initializing color variant display:', error);
  }
}

setupSwatchHoverEvents() {
  const swatches = document.querySelectorAll('.color-swatch:not(.disabled)');
 
  swatches.forEach(swatch => {
    const cardWrapper = swatch.closest('.card-wrapper');
    if (!cardWrapper) return;

    const secondaryImage = cardWrapper.querySelector('.media--hover-effect img:last-child');
    if (!secondaryImage) return;

    const variantImageUrl = swatch.dataset.imageUrl;
    if (!variantImageUrl || variantImageUrl === 'undefined' || variantImageUrl.includes('Liquid error')) return;

    // Store original srcset and src
    const originalSrcset = secondaryImage.srcset;
    const originalSrc = secondaryImage.src;

    swatch.addEventListener('mouseenter', () => {
      // Update secondary image with variant image
      secondaryImage.srcset = '';
      secondaryImage.src = variantImageUrl;
    });

    swatch.addEventListener('mouseleave', () => {
      // Restore original image
      secondaryImage.srcset = originalSrcset;
      secondaryImage.src = originalSrc;
    });
  });
}

switchProductImage(card, imageUrl) {
  try {
    if (!imageUrl || imageUrl === 'undefined' || imageUrl.includes('Liquid error')) {
      return;
    }

    const productImage = card.querySelector('.card__media img');
    if (productImage) {
      // Create a new image element
      const newImage = new Image();
     
      // Generate srcset for different sizes
      const sizes = [165, 360, 533, 720, 940, 1066];
      const srcset = sizes.map(size => {
        const sizeUrl = imageUrl.replace(/width=\d+/, `width=${size}`);
        return `${sizeUrl} ${size}w`;
      }).join(', ');
     
      newImage.srcset = srcset;
      newImage.sizes = "(min-width: 990px) calc((100vw - 130px) / 4), (min-width: 750px) calc((100vw - 120px) / 3), calc((100vw - 35px) / 2)";
      newImage.src = imageUrl;
     
      // When the new image is loaded, swap it immediately
      newImage.onload = () => {
        productImage.srcset = srcset;
        productImage.sizes = newImage.sizes;
        productImage.src = imageUrl;

        // keep the swipeable photos (phones) in sync with the chosen colour
        var firstSlide = card.querySelector('.card-swipe__slide');
        if (firstSlide) {
          firstSlide.srcset = srcset;
          firstSlide.sizes = newImage.sizes;
          firstSlide.src = imageUrl;
          var swipeTrack = card.querySelector('.card-swipe__track');
          if (swipeTrack) swipeTrack.scrollTo({ left: 0, behavior: 'smooth' });
        }
      };

      // Handle image load errors
      newImage.onerror = () => {
        console.error('Failed to load variant image:', imageUrl);
      };
    }
  } catch (error) {
    console.error('Error switching product image:', error);
  }
}
}

// Initialize when DOM is loaded
if (document.readyState === 'loading') {
document.addEventListener('DOMContentLoaded', () => {

  new ColorVariantDisplay();
});
} else {
 new ColorVariantDisplay();
}

// Wait until the DOM is fully loaded
document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.card__inner').forEach(function (card) {
    // Change cursor on hover
    card.style.cursor = 'pointer';
     // On click, trigger click on .full-unstyled-link inside the card
    card.addEventListener('click', function () {
      const link = card.querySelector('.full-unstyled-link');
      if (link) {
        link.click();
      }
    });
  });
});
// Initialize the functionality
customElements.define('color-variant-display', class extends HTMLElement {
constructor() {
  super();
  new ColorVariantDisplay();
}
});

/* ------------------------------------------------------------------
   Swipeable product-card photos (phones / tablets only).
   Swipe a card's photo left/right to see the product's other photos.
   Desktop keeps the original hover-to-show-second-photo behaviour.
   ------------------------------------------------------------------ */
(function () {
  if (window.__cardSwipeInit) return;
  window.__cardSwipeInit = true;
  if (!window.matchMedia || !window.matchMedia('(hover: none) and (pointer: coarse)').matches) return;
  if (!('IntersectionObserver' in window) || !window.fetch) return;

  var MAX_SLIDES = 5;
  var cache = {};
  var shopRoot = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  function sized(url, w) {
    return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
  }

  function loadPhotos(handle) {
    if (!cache[handle]) {
      cache[handle] = fetch(shopRoot + 'products/' + handle + '.js', { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (p) {
          if (!p) return null;
          var out = [];
          (p.media || []).forEach(function (m) {
            if (m.media_type === 'image' && m.src) out.push({ src: m.src, alt: m.alt || p.title });
          });
          if (!out.length) {
            (p.images || []).forEach(function (src) { out.push({ src: src, alt: p.title }); });
          }
          return out.slice(0, MAX_SLIDES);
        })
        .catch(function () { return null; });
    }
    return cache[handle];
  }

  function build(card, photos) {
    var media = card.querySelector('.card__media .media');
    if (!media || media.querySelector('.card-swipe') || !photos || photos.length < 2) return;

    var wrap = document.createElement('div');
    wrap.className = 'card-swipe';
    wrap.setAttribute('data-card-swipe', '');
    wrap.style.setProperty('--swipe-n', photos.length);

    var track = document.createElement('div');
    track.className = 'card-swipe__track';

    photos.forEach(function (photo, i) {
      var img = document.createElement('img');
      img.className = 'card-swipe__slide';
      img.srcset = [360, 533, 720].map(function (w) { return sized(photo.src, w) + ' ' + w + 'w'; }).join(', ');
      img.src = sized(photo.src, 533);
      img.sizes = '(min-width: 750px) calc((100vw - 120px) / 3), calc((100vw - 35px) / 2)';
      img.alt = photo.alt || '';
      img.loading = i === 0 ? 'eager' : 'lazy';
      img.decoding = 'async';
      img.draggable = false;
      if (i === 0) {
        var show = function () {
          media.classList.add('has-swipe');
          // lift the photo area above the card's full-card link so it can receive the swipe
          if (media.parentElement) media.parentElement.classList.add('card__media--swipe');
        };
        img.addEventListener('load', show);
        if (img.complete && img.naturalWidth) show();
      }
      track.appendChild(img);
    });

    var bar = document.createElement('div');
    bar.className = 'card-swipe__bar';
    bar.setAttribute('aria-hidden', 'true');
    var thumb = document.createElement('span');
    thumb.className = 'card-swipe__thumb';
    thumb.style.width = (100 / photos.length) + '%';
    bar.appendChild(thumb);

    // a tap (not a swipe) on the photo opens the product, like before
    wrap.addEventListener('click', function (e) {
      var link = card.querySelector('.full-unstyled-link');
      if (link) {
        e.stopPropagation();
        link.click();
      }
    });

    wrap.appendChild(track);
    wrap.appendChild(bar);
    media.appendChild(wrap);
  }

  function setup(card) {
    if (card.dataset.swipeInit) return;
    card.dataset.swipeInit = '1';
    var link = card.querySelector('a[href*="/products/"]');
    var m = link && link.getAttribute('href').match(/\/products\/([^\/?#]+)/);
    if (!m) return;
    loadPhotos(m[1]).then(function (photos) { build(card, photos); });
  }

  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        io.unobserve(entry.target);
        setup(entry.target);
      }
    });
  }, { rootMargin: '400px 0px' });

  function watch(scope) {
    var cards = scope.matches && scope.matches('.card-wrapper') ? [scope] : [];
    if (scope.querySelectorAll) cards = cards.concat(Array.prototype.slice.call(scope.querySelectorAll('.card-wrapper')));
    cards.forEach(function (c) { if (!c.dataset.swipeInit) io.observe(c); });
  }

  function start() {
    watch(document);
    // cards added later (infinite scroll, filters, search)
    new MutationObserver(function (list) {
      list.forEach(function (rec) {
        rec.addedNodes.forEach(function (n) { if (n.nodeType === 1) watch(n); });
      });
    }).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();

  // progress line under the photo (scroll events don't bubble -> capture phase)
  document.addEventListener(
    'scroll',
    function (e) {
      var t = e.target;
      if (t && t.classList && t.classList.contains('card-swipe__track')) {
        window.requestAnimationFrame(function () {
          var max = t.scrollWidth - t.clientWidth;
          var p = max > 0 ? t.scrollLeft / max : 0;
          if (t.parentElement) t.parentElement.style.setProperty('--swipe-p', Math.min(1, Math.max(0, p)).toFixed(4));
        });
      }
    },
    { capture: true, passive: true }
  );
})();

/* ------------------------------------------------------------------
   Tapping a colour circle on a product card only changes the photo.
   It no longer opens the product page (capture phase runs before the
   theme's older click handlers, which navigate to the product).
   ------------------------------------------------------------------ */
document.addEventListener(
  'click',
  function (e) {
    var swatch = e.target && e.target.closest ? e.target.closest('.card-wrapper .color-swatch') : null;
    if (!swatch) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    if (swatch.disabled || swatch.classList.contains('disabled')) return;
    var card = swatch.closest('.card-wrapper');
    var url = swatch.dataset.imageUrl;
    if (card && url && url !== 'undefined' && url.indexOf('Liquid error') === -1) {
      ColorVariantDisplay.prototype.switchProductImage.call(null, card, url);
    }
  },
  true
);